module.exports = __webpack_public_path__ + "img/selected_company_radio_button_boardpage.f1a2f2bb.svg";